import { Component, OnInit } from '@angular/core';

import { default_FilterDrawerLayoutComponent } from '../../default/filter-drawer-layout/filter-drawer-layout.component';
import moment from 'moment';
import { FilterDrawerLayoutFilterTypes } from '@app/client/classes/filter-drawer-layout-component.class';
import { FilterSetupType } from '@app/data/services/filterService';

@Component({
  selector: 'app-client-filter-drawer-layout',

  templateUrl: '../../default/filter-drawer-layout/filter-drawer-layout.component.html',
  styleUrls: ['../../default/filter-drawer-layout/filter-drawer-layout.component.scss'],
})
export class wastemanagement_FilterDrawerLayoutComponent extends default_FilterDrawerLayoutComponent implements OnInit {
  hasStreamBranding: boolean = false;

  // override the filters in use for this client, hides the text filter and download options
  filtersInUse: Record<FilterDrawerLayoutFilterTypes, FilterSetupType[]> = {
    type: ['taiao', 'sitehealth', 'mapview', 'maramataka'],
    domain: ['taiao', 'sitehealth'],
    timescale: ['taiao', 'mapview'],
    textfilter: [],
    csvDownload: [],
    surfaceSites: ['mapview'],
    mapFeatures: ['mapview'],
    baseMap: ['mapview'],
    dataLayers: ['mapview'],
    matauranga: ['maramataka'],
    monitoring: ['maramataka'],
    observations: [],
    calendarView: ['maramataka'],
    locationFilter: [],
    environmentalDataSourcesFilter: ['taiao'],
    environmentalDataSourcesDashGroupsFilter: ['taiao'],
    contributingOrganisationsFilter: ['taiao'],
    contributingProjectsFilter: ['taiao'],
  };

  ngOnInit(): void {
    super.ngOnInit();
    this.brandPadding = false;
    // override default map features options, this hides observations
    this.defaultMapFeaturesOptions = this.compileOptions<string>('mapFeatures', [
      { key: 'monitor', value: 'Monitoring Stations' },
    ]);
  }
}
